import React, { useState, useEffect } from 'react';
import style from './theme.module.sass';
import { Form, Input } from 'antd';
import { useParams } from 'react-router-dom';
import { Http } from '../../../helpers/axois';
import { useDispatch } from 'react-redux';
import { pushToast } from '../../../stateManager/store/toast/actions';
import { setCurrentTheme } from '../../../stateManager/store/orgs/actions';
import { logger } from '../../../constant/winston';

const Theme: React.FC<any> = (props: any) => {
  const [themeName, setthemeName] = useState<any>();
  const [initialCount, setinitialCount] = useState(0);
  const params: any = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (initialCount === 0) {
      if (props.initialState) {
        setthemeName(props.initialState.theme_name)
      }
      setinitialCount(1);
    }
    return () => {

    };
  }, [initialCount, props])

  const onSumbit = () => {
    const editData = props.initialState;
    logger.log("on submit", props.source, props.initialState, themeName, params.orgId)
    if (editData) {
      const arnName = `themes:${editData.theme_id}`
      Http.put(`themes/${editData.theme_id}?arn=${arnName}`, { name: themeName, orgId: params.orgId }).subscribe((res) => {
        props.getTheme();
        dispatch(pushToast({ type: 'success', message: 'Theme updated successfully' }))
      }, (err) => {
        dispatch(pushToast({ type: 'error', message: (err && err.message) ? err.message : 'Theme updation failed' }))
      })
    } else {
      Http.post('themes', { name: themeName, orgId: params.orgId, source: (props.source) ? props.source : {} }).subscribe((res: any) => {
        props.getTheme();
        dispatch(setCurrentTheme({
          id: res[0].theme_id,
          source: res[0].source
        }))
        dispatch(pushToast({ type: 'success', message: 'Theme created successfully' }))
      }, (err) => {
        dispatch(pushToast({ type: 'error', message: (err && err.message) ? err.message : 'Theme creation failed' }))
      })
    }
  }
  props.onSumbit(onSumbit);
  return (<Form.Item label={<span className={style.labelName}>Theme Name</span>}>
    <Input
      data-test-id="theme_name"
      value={themeName}
      onChange={e => (setthemeName(e.target.value))}
    />
  </Form.Item>)
}

export default Theme;